const routes = [
  {
    path: 'ems-dashboard',
    component: () => import(/* webpackChunkName: "ems-dashboard" */ './views/Index.vue'),
    meta: {
      permissionRequired: false,
    },
    children: [
      {
        path: '',
        name: 'emsDashboard',
        component: () => import(/* webpackChunkName: "ems-dashboard" */ './views/emsDashboard.vue'),
      },
    ],
  },
];

export default routes;
